import * as Api from '@ViewModels';
import { HandwrittenCardBalanceDisplay } from '../../../containers/account/AccountDetails/HandwrittenCardBalanceDisplay';
import {
	appliedRenewalDiscountDisplay,
	extraUsersDisplay,
	isPaidAccount,
	lastBillingAmountDisplay,
	lastBillingDateDisplay,
	mrrDisplay,
} from '../accountOverviewFormatters';
import { OverviewHoverPanel, OverviewHoverRow } from './OverviewHoverPanel';

/**
 * Whether the Plan field has a details panel to hover. Gate the info affordance on this rather
 * than on the element: a component that returns null is still a truthy prop, which would leave an
 * info icon opening an empty card.
 */
export const hasPlanDetails = (account?: Api.IAccount): boolean => isPaidAccount(account);

/**
 * The Billing card's "Plan Details" hover panel — a port of the legacy Plan field popover.
 *
 * Repeats the billing figures the card also lists as fields so the plan can be read in one place,
 * adds the applied Chargify discount by name, and appends the handwritten-card balance when that
 * feature is on.
 */
export const PlanDetailsPanel = ({ account }: { account: Api.IAccount }) => {
	if (!isPaidAccount(account)) {
		return null;
	}

	return (
		<OverviewHoverPanel title='Plan Details'>
			<OverviewHoverRow label='MRR'>{mrrDisplay(account)}</OverviewHoverRow>
			<OverviewHoverRow label='Extra users'>{extraUsersDisplay(account)}</OverviewHoverRow>
			<OverviewHoverRow label='Last Billing Amount'>{lastBillingAmountDisplay(account)}</OverviewHoverRow>
			<OverviewHoverRow label='Last Billing Date'>{lastBillingDateDisplay(account)}</OverviewHoverRow>
			<OverviewHoverRow label='Renewal Discount'>{appliedRenewalDiscountDisplay(account)}</OverviewHoverRow>
			{!!account.features?.handwrittenCards?.enabled && <HandwrittenCardBalanceDisplay account={account} />}
		</OverviewHoverPanel>
	);
};
